import React from 'react';

import Logo from './logo';
import { SidebarMenuButton, SidebarTrigger } from './ui/sidebar';

const UserMenu = () => {
    return (
        <div className="flex justify-between items-center w-full group/menu min-h-[48px]">
            <SidebarMenuButton
                size="lg"
                className="cursor-default hover:bg-transparent transition-opacity duration-200 group-hover/menu:group-data-[state=collapsed]:opacity-0"
            >
                <Logo textClassName="text-foreground" />
            </SidebarMenuButton>
            <SidebarTrigger
                className="h-8 w-8 p-0 flex items-center justify-center text-slate-400 hover:text-primary hover:scale-110 transition-all duration-200 group-data-[state=collapsed]:hidden"
                data-testid="SidebarTrigger"
            />
            <SidebarTrigger
                className="h-8 w-8 p-0 flex items-center justify-center text-slate-400 hover:text-primary hover:scale-110 transition-all duration-200 hidden group-hover/menu:group-data-[state=collapsed]:flex absolute left-1/2 -translate-x-1/2"
                data-testid="SidebarTriggerCollapsed"
            />
        </div>
    );
};

export default UserMenu;
